export function checkIfLocationSpecificPage(path) {
    // Check if the user is on a location summary page (if the path contains 'locations' but is not followed by 'list' or 'map')
    const locationsRegex = /locations(?!\/list|\/map)/;
    // Check if the user is on a location detail page (if path contains ('kw-demand'))
    const kwDemandRegex = /kw-demand/;
    return (kwDemandRegex.test(path) || locationsRegex.test(path));
}

// Converts accented characters to unaccented characters and replaces special EU characters with their unaccented equivalents
// Used to enable accent-insensitive searching and comparison
export function convertToPlainText(value, skipLowercase = false) {
    if (!value) return '';
    let result = value
        .normalize("NFD") // decomposes combined letters into letter + accent
        .replace(/\p{M}/gu, "") // removes all accent marks
        // replaces EU special letters that aren't marks
        .replace(/ß/g, "ss") 
        .replace(/æ/g, "ae")
        .replace(/œ/g, "oe")
        .replace(/ø/g, "o")
        .replace(/đ/g, "d")
        .replace(/ł/g, "l");

    if (!skipLowercase) {
        result = result.toLowerCase();
    }

    return result;
}